<template>
<div class="elevator-buttons" :class="elevatorButtonsClass">
  <template v-for="level in levels">
    <b-button v-if="level == nowLevel" :key="level" :variant="($route.name === 'Home' && homeSwiperIndex <= 1)? 'light': 'dark'" pill class="futura">
      {{ ( '00' + level ).slice( -2 ) }}
    </b-button>
    <b-button v-else :key="level" :variant="($route.name === 'Home' && homeSwiperIndex <= 1)? 'outline-light': 'outline-dark'" pill class="futura" @click="onClick(level)">
      {{ ( '00' + level ).slice( -2 ) }}
    </b-button>
  </template>
</div>
</template>

<script>
import { mapState } from 'vuex'
import isMobile from 'ismobilejs'

export default {
  name: 'ElevatorButtons',
  data() {
    return {
      isMobile
    }
  },
  computed: {
    ...mapState({
      exhibitionPages: state => state.exhibitionPages,
      exhibitionMaxPages: state => state.exhibitionMaxPages,
      homeSwiperIndex: state => state.homeSwiperIndex
    }),
    levels() {
      if (this.$route.name === 'Home') {
        if (this.homeSwiperIndex == 1) {
          return this.exhibitionMaxPages + 1
        } else if (this.homeSwiperIndex == 2) {
          return 4
        } else {
          return 1
        }
      } else if (this.$route.name === 'artwork2') {
        return 4
      } else if (this.$route.name === 'artworkMaking') {
        return 4
      } else if (this.$route.name === 'pastWorks') {
        return 4
      } else if (this.$route.name === 'exhibition') {
        return this.exhibitionMaxPages + 1
      } else {
        // console.log(this.$route.name)
        return 1
      }
    },
    nowLevel() {
      if (this.$route.name === 'Home') {
        return 1
      } else if (this.$route.name === 'artwork2') {
        return 2
      } else if (this.$route.name === 'artworkMaking') {
        return 3
      } else if (this.$route.name === 'pastWorks') {
        return 4
      } else if (this.$route.name === 'exhibition') {
        return parseInt(this.exhibitionPages) + 1
      } else {
        // console.log(this.$route.name)
        return 3
      }
    },
    elevatorButtonsClass() {
      if (this.$route.name === 'Home') {
        if (this.homeSwiperIndex == 1 || this.homeSwiperIndex == 2) {
          return 'show'
        } else {
          return ''
        }
      } else {
        return 'show'
      }
    }
  },
  methods: {
    onClick(level) {
      if (this.$route.name === 'Home') {
        if (location.hash === "#profile") {
          this.$router.push({ name: 'exhibition', params:{pageNo: '' + (level-1)} })
        } else if (location.hash === '#artwork') {
          if (level == 2) {
            this.$router.push({name: 'artwork2'})
          } else if (level == 3) {
            this.$router.push({name: 'artworkMaking'})
          } else {
            this.$router.push({name: 'pastWorks'})
          }
        }
      } else if (this.$route.name === 'exhibition') {
        if (level == 1) {
          this.$router.push({ name: 'Home', hash: '#profile' })
        } else {
          this.$router.push({ name: 'exhibition', params:{pageNo: '' + (level-1)} })
        }
      } else if (this.$route.name === 'artwork2' || this.$route.name === 'artworkMaking' || this.$route.name === 'pastWorks') {
        if (level == 1) {
          this.$router.push({ name: 'Home', hash: '#artwork' })
        } else if (level == 2) {
          this.$router.push({ name: 'artwork2' })
        } else if (level == 3) {
          this.$router.push({ name: 'artworkMaking' })
        } else if (level == 4) {
          this.$router.push({ name: 'pastWorks' })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.elevator-buttons {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 1;
  width: 35px;
  opacity: 0;
  transition: opacity 0.6s;
  pointer-events: none;
  @media screen and (min-width: 768px){
    bottom: 60px;
    right: 53px;
  }
  &.show {
    opacity: 1;
    pointer-events: inherit;
  }
  >.btn {
    display: inline-block;
    width: 35px;
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 6px;
  }
}
</style>